import { useEffect } from 'react';

interface MetaTagsConfig {
  title: string;
  description: string;
  image?: string;
  url?: string;
  type?: string;
  siteName?: string;
  twitterCard?: string;
  twitterSite?: string;
  twitterCreator?: string;
}

export const useMetaTags = (config: MetaTagsConfig) => {
  useEffect(() => {
    const updateMetaTag = (name: string, content: string) => {
      let meta = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement;
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = name;
        document.head.appendChild(meta);
      }
      meta.content = content;
    };

    const updatePropertyMetaTag = (property: string, content: string) => {
      let meta = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement;
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('property', property);
        document.head.appendChild(meta);
      }
      meta.content = content;
    };

    // Update document title
    document.title = config.title;

    // Basic meta tags
    updateMetaTag('description', config.description);

    // Open Graph tags (Facebook, LinkedIn, etc.)
    updatePropertyMetaTag('og:title', config.title);
    updatePropertyMetaTag('og:description', config.description);
    updatePropertyMetaTag('og:type', config.type || 'website');
    updatePropertyMetaTag('og:site_name', config.siteName || 'Geek');
    
    if (config.url) {
      updatePropertyMetaTag('og:url', config.url);
    }
    
    if (config.image) {
      updatePropertyMetaTag('og:image', config.image);
      updatePropertyMetaTag('og:image:width', '1200');
      updatePropertyMetaTag('og:image:height', '630');
      updatePropertyMetaTag('og:image:type', 'image/jpeg');
    }

    // Twitter Card tags
    updateMetaTag('twitter:card', config.twitterCard || 'summary_large_image');
    updateMetaTag('twitter:title', config.title);
    updateMetaTag('twitter:description', config.description);
    
    if (config.twitterSite) {
      updateMetaTag('twitter:site', config.twitterSite);
    }
    
    if (config.twitterCreator) {
      updateMetaTag('twitter:creator', config.twitterCreator);
    }
    
    if (config.image) {
      updateMetaTag('twitter:image', config.image);
    }

    // Cleanup function to reset meta tags when component unmounts
    return () => {
      // Reset to default meta tags
      document.title = 'Geek';
      updateMetaTag('description', 'Web site created using create-react-app');
      
      // Remove Open Graph tags
      const ogTags = document.querySelectorAll('meta[property^="og:"]');
      ogTags.forEach(tag => tag.remove());
      
      // Remove Twitter tags
      const twitterTags = document.querySelectorAll('meta[name^="twitter:"]');
      twitterTags.forEach(tag => tag.remove());
    };
  }, [config]);
}; 